import { motion } from "framer-motion";
import { Star, Plus } from "lucide-react";
import { formatBRL } from "../api";
import { useStore } from "../context/StoreContext";

export function ProductCard({ product, index }) {
  const { setSelected } = useStore();
  return (
    <motion.article
      data-testid={`vult-product-card-${product.id}`}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.45, delay: (index % 4) * 0.06 }}
      onClick={() => setSelected(product)}
      className="group cursor-pointer overflow-hidden rounded-3xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-1.5 hover:border-slate-900 hover:shadow-[8px_8px_0_#0F172A]"
    >
      <div className="relative aspect-square overflow-hidden bg-[#F8F9FA]">
        <img
          data-testid={`vult-product-card-img-${product.id}`}
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-108 group-hover:scale-105"
        />
        {product.badge && (
          <span className={`absolute left-3 top-3 rounded-full px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-widest ${product.badge_color || "bg-yellow-400 text-slate-900"}`}>
            {product.badge}
          </span>
        )}
        <button
          data-testid={`vult-product-quick-add-btn-${product.id}`}
          onClick={(e) => { e.stopPropagation(); setSelected(product); }}
          className="absolute bottom-3 right-3 flex h-11 w-11 translate-y-2 items-center justify-center rounded-full bg-slate-900 text-white opacity-0 transition-all duration-300 hover:bg-vult-red hover:text-slate-900 group-hover:translate-y-0 group-hover:opacity-100"
          aria-label="Adicionar rápido"
        >
          <Plus size={18} />
        </button>
      </div>
      <div className="p-3 sm:p-5">
        <div className="mb-1 flex items-center justify-between">
          <span className="font-mono text-[10px] font-bold uppercase tracking-widest text-vult-blue">{product.brand}</span>
          <span className="flex items-center gap-1 font-mono text-[11px] font-bold text-slate-600">
            <Star size={12} className="fill-amber-400 text-amber-400" /> {product.rating}
            <span className="hidden font-medium text-slate-400 sm:inline">({product.reviews_count})</span>
          </span>
        </div>
        <h3 className="font-display text-base font-bold uppercase leading-tight text-slate-900 sm:text-xl">{product.name}</h3>
        <div className="mt-2 flex flex-wrap items-baseline gap-2 sm:mt-3">
          <span className="font-display text-lg font-black text-slate-900 sm:text-2xl">{formatBRL(product.price)}</span>
          {product.old_price && (
            <span className="text-xs font-medium text-slate-400 line-through sm:text-sm">{formatBRL(product.old_price)}</span>
          )}
        </div>
      </div>
    </motion.article>
  );
}
